module.exports = __webpack_public_path__ + "assets/img/more-btn-e7fc3eeb.png";